export default "<app-header2></app-header2>\r\n<p>dashboard works!</p>\r\n";